import React, { useState, useEffect, useContext } from "react";
import AddToCart from "../../components/AddToCart/AddToCart";
import Description from "../../components/Description/Description";
import PopupNotes from "../../components/PopupNotes/PopupNotes";
import SmallModal from "../../components/SmallModal/SmallModal";
import { AppContext } from "../../context";
import { MONUMENT } from "./monumentConstants";
import { addTicketToCart } from "./addTicketToCart";
import TicketInfoTable from "./TicketInfoTable";

function MonumentCardContent({
  product,
  context,
  setIsAddedToCartVisible,
  setAddedToCart,
  clientRequest,
}) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const [numberOfTickets, setNumberOfTickets] = useState(1);
  const info = useContext(AppContext);

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return <Description description={product?.gen_description} />;
      case "reservation-info":
        return (
          <>
            <div className="ahp-reservation-content">
              <div
                className="ahp-info-table"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <TicketInfoTable
                  orientation="horizontal"
                  price={product.gen_price * numberOfTickets}
                  date={info.monument?.date?.toISOString(true).split("T")[0]}
                  numberOfTickets={numberOfTickets}
                  setNumberOfTickets={setNumberOfTickets}
                  showSelect
                />
              </div>

              <AddToCart
                setIsAddedToCartVisible={setIsAddedToCartVisible}
                handleAddToCart={() =>
                  addTicketToCart({
                    product,
                    info,
                    quantity: numberOfTickets,
                    clientRequest,
                    setAddedToCart,
                  })
                }
              />
            </div>
          </>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <div className="ahp-reservation-content">
            <TicketInfoTable
              orientation="vertical"
              price={product.total_price}
              date={product.date}
              numberOfTickets={product.quantity}
              setNumberOfTickets={setNumberOfTickets}
            />
            <PopupNotes notes={product.request} />
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div>
      {product?.gen_price !== null &&
        product?.gen_price !== 0 &&
        context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product?.status === "not-available" ||
          product?.status === "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">
              {product?.gen_price || product.total_price} €
            </div>
            <div
              className="ahp-price-info"
              onClick={() => setIsPriceModalVisible(true)}
            >
              i
            </div>
          </div>
        )}
      {selectComponent()}
      <SmallModal
        text="Preço por dia."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
        width="200px"
      />
    </div>
  );
}

export default MonumentCardContent;
